/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * My App
 * This is an awesome app!
 * OpenAPI spec version: 1.0.0
 */
import type {
  AccessDeniedErrorResponse,
  BadRequestErrorResponse,
  NotFoundErrorResponse,
  PropertyCommissionApiResource,
  UnauthorizedErrorResponse,
  UpsertPropertyCommissionRequest
} from '.././models';

import { customFetch } from '../../custom-fetch';

export type getApiPropertyCommissionGetResponse200 = {
  data: PropertyCommissionApiResource
  status: 200
}

export type getApiPropertyCommissionGetResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type getApiPropertyCommissionGetResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type getApiPropertyCommissionGetResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type getApiPropertyCommissionGetResponseSuccess = (getApiPropertyCommissionGetResponse200) & {
  headers: Headers;
};
export type getApiPropertyCommissionGetResponseError = (getApiPropertyCommissionGetResponse401 | getApiPropertyCommissionGetResponse403 | getApiPropertyCommissionGetResponse404) & {
  headers: Headers;
};

export type getApiPropertyCommissionGetResponse = (getApiPropertyCommissionGetResponseSuccess | getApiPropertyCommissionGetResponseError)

export const getGetApiPropertyCommissionGetUrl = (id: string,) => {


  

  return `/api/properties/${id}/commission`
}

export const getApiPropertyCommissionGet = async (id: string, options?: RequestInit): Promise<getApiPropertyCommissionGetResponse> => {
  
  return customFetch<getApiPropertyCommissionGetResponse>(getGetApiPropertyCommissionGetUrl(id),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}


export type putApiPropertyCommissionUpsertResponse200 = {
  data: PropertyCommissionApiResource
  status: 200
}

export type putApiPropertyCommissionUpsertResponse400 = {
  data: BadRequestErrorResponse
  status: 400
}

export type putApiPropertyCommissionUpsertResponse401 = {
  data: UnauthorizedErrorResponse
  status: 401
}

export type putApiPropertyCommissionUpsertResponse403 = {
  data: AccessDeniedErrorResponse
  status: 403
}

export type putApiPropertyCommissionUpsertResponse404 = {
  data: NotFoundErrorResponse
  status: 404
}
    
export type putApiPropertyCommissionUpsertResponseSuccess = (putApiPropertyCommissionUpsertResponse200) & {
  headers: Headers;
};
export type putApiPropertyCommissionUpsertResponseError = (putApiPropertyCommissionUpsertResponse400 | putApiPropertyCommissionUpsertResponse401 | putApiPropertyCommissionUpsertResponse403 | putApiPropertyCommissionUpsertResponse404) & {
  headers: Headers;
};

export type putApiPropertyCommissionUpsertResponse = (putApiPropertyCommissionUpsertResponseSuccess | putApiPropertyCommissionUpsertResponseError)

export const getPutApiPropertyCommissionUpsertUrl = (id: string,) => {


  

  return `/api/properties/${id}/commission`
}

export const putApiPropertyCommissionUpsert = async (id: string,
    upsertPropertyCommissionRequest: UpsertPropertyCommissionRequest, options?: RequestInit): Promise<putApiPropertyCommissionUpsertResponse> => {
  
  return customFetch<putApiPropertyCommissionUpsertResponse>(getPutApiPropertyCommissionUpsertUrl(id),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      upsertPropertyCommissionRequest,)
  }
);}


